// extracted by mini-css-extract-plugin
export default {"folioRecordTypeContainer":"folioRecordTypeContainer---F_Ohm","error":"error---mgrkA"};